import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  REQUEST_GET_ALL_PROJECTS_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_PROJECT_DATA,
  REQUEST_GET_USER_DATA_FOR_ADMIN,
  REQUEST_GET_ALL_ACTIVITIES,
  REQUEST_GET_ACTIVITY_DATA,
} from '../../Redux/constants/constants';
import { Radio, Table, AutoComplete, Icon, Tooltip } from 'antd';
import { VerticalMargin } from '../../Helper/VerticalMargin.Styles';
import FlexGroup from '../../Helper/FlexGroup.Styles';

const { Column } = Table;
const { Option } = AutoComplete;

const getAllAction = {
  projects: REQUEST_GET_ALL_PROJECTS_FOR_ADMIN,
  users: REQUEST_GET_ALL_USERS_FOR_ADMIN,
  usersInStage: REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN, // TODO check if used
  activities: REQUEST_GET_ALL_ACTIVITIES,
};

const onSelectAction = {
  projects: REQUEST_GET_PROJECT_DATA,
  users: REQUEST_GET_USER_DATA_FOR_ADMIN,
  activities: REQUEST_GET_ACTIVITY_DATA,
};

const text = {
  projects: {
    searchPlaceholder: 'Znajdź projekt',
    inactive: 'archived',
  },
  users: {
    searchPlaceholder: 'Znajdź',
    inactive: 'inactive',
  },
  activities: {
    searchPlaceholder: 'Znajdź aktywność',
    inactive: 'inactive',
  },
};

const DynamicTable = ({ type, userView }) => {
  // TODO change userView to simpleView
  const dispatch = useDispatch();
  const [status, setStatus] = useState('active');
  const dataList = useSelector((state) => state[type]);
  const activeData = dataList.filter((item) => item.status === 'active');
  const inactiveData = dataList.filter((item) => item.status !== 'active');
  const data = status === 'active' ? activeData : inactiveData;

  useEffect(() => {
    dispatch({ type: getAllAction[type] });
  }, [type]);

  const dataForAutoComplete = (data) =>
    data.map((item) => (
      <Option key={item.id}>
        {item.number ? `${item.number} - ${item.name}` : `${item.name}`}
      </Option>
    ));

  const changeStatus = (value) => setStatus(value);

  const onSelect = (value) => {
    dispatch({ type: onSelectAction[type], payload: value });
  };

  return (
    <>
      <VerticalMargin>
        <FlexGroup>
          {/* <div style={{ marginRight: '8px', flexGrow: '3' }}> */}
          <AutoComplete
            style={{
              flexGrow: '3',
              marginRight: '8px',
              marginBottom: '8px',
            }}
            placeholder={text[type].searchPlaceholder}
            onSelect={onSelect}
            allowClear
            filterOption={(inputValue, option) =>
              option.props.children
                .toUpperCase()
                .indexOf(inputValue.toUpperCase()) !== -1
            }
          >
            {dataForAutoComplete(data)}
          </AutoComplete>
          {!userView && (
            <Radio.Group
              value={status}
              onChange={(e) => changeStatus(e.target.value)}
            >
              <FlexGroup>
                <Radio.Button value="active">active</Radio.Button>
                <Radio.Button value="inactive">
                  {text[type].inactive}
                </Radio.Button>
              </FlexGroup>
            </Radio.Group>
          )}
        </FlexGroup>
      </VerticalMargin>
      {type === 'projects' && (
        <Table
          tableLayout="fixed"
          rowKey={(record) => record.id}
          dataSource={status === 'active' ? activeData : inactiveData}
          pagination={data.length > 10}
          style={{ cursor: 'pointer' }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => onSelect(record.id),
            };
          }}
        >
          <Column
            title="Numer"
            dataIndex="number"
            key="number"
            width="32%"
            ellipsis="true"
            sorter={(a, b) => a.number.localeCompare(b.number)}
            sortDirections={['descend', 'ascend']}
            defaultSortOrder="ascend"
          />
          <Column title="Nazwa" dataIndex="name" key="name" ellipsis="true" />
        </Table>
      )}
      {type === 'activities' && (
        <Table
          tableLayout="fixed"
          rowKey={(record) => record.id}
          showHeader={false}
          dataSource={status === 'active' ? activeData : inactiveData}
          pagination={data.length > 10}
          style={{ cursor: 'pointer' }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => onSelect(record.id),
            };
          }}
        >
          <Column dataIndex="name" key="name" ellipsis="true" />
        </Table>
      )}
      {type === 'users' && (
        <Table
          tableLayout="fixed"
          rowKey={(record) => record.id}
          showHeader={false}
          dataSource={status === 'active' ? activeData : inactiveData}
          pagination={data.length > 10}
          style={{ cursor: 'pointer' }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => onSelect(record.id),
            };
          }}
        >
          <Column dataIndex="name" key="name" ellipsis="true" />
          <Column
            dataIndex="pendingClaim"
            key="pendingClaim"
            ellipsis="true"
            width="18%"
            render={(cell) => {
              return cell ? (
                <Tooltip title="nowy wniosek">
                  <Icon type="info-circle" theme="twoTone" />
                </Tooltip>
              ) : null;
            }}
          />
          <Column
            dataIndex="weekNotClosed"
            key="weekNotClosed"
            ellipsis="true"
            width="18%"
            render={(cell) => {
              return cell ? (
                <Tooltip title="tydzień nie zamknięty">
                  <Icon type="unlock" theme="twoTone" />
                </Tooltip>
              ) : null;
            }}
          />
          {/* TODO render ={} ... po zmianie do ant v4 tu moze byc inne api */}
        </Table>
      )}
    </>
  );
};

export default DynamicTable;
